module.exports = __webpack_public_path__ + "static/media/udayyy.ed681684.png";